import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Radio from '@mui/material/Radio';
import Typography from '@mui/material/Typography';
import thumb from '../../../images/people/picthumb1.png';
import ThinCircleIcon from '../../shared/ThinCircleIcon';
import DotCircleIcon from '../../shared/DotCircleIcon';
import { PeopleMetadata } from '../../../model/enrollment';

const RowText = styled(Typography)(({ theme }) => ({
    textAlign: 'center',
    color: theme.palette.text.primary,
    fontSize: 18 
}));


interface EnrollmentListRowProps {
    data?: PeopleMetadata;
}



export default function EnrollmentListRow({ data }: EnrollmentListRowProps) {

    const label = { inputProps: { 'aria-label': 'Checkbox demo' } };


    const actionColor = data?.action === 'Alert Police' ? 'error.main' : (data?.action === 'Observe' ? 'success.light' : 'warning.main')

    return (
         <Stack direction="row" spacing={1} sx={{ alignItems: 'center'}}>

            <Stack direction="row" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', flex: '1 0 15%', ml: 0 }}>
                <Radio 
                sx={{
                    width: '45px',
                    mr: 3,
                    ml: 1
                }}
                icon={<ThinCircleIcon  viewBox="0 0 48 50" sx={{ width: 40, height: 40, color: 'secondary.main'}} />} 
                checkedIcon={<DotCircleIcon viewBox="0 0 32 32"  sx={{ width: 45, height: 45, color: 'secondary.main', ml: '-2px'}} />}
                />
                <img alt="person" src={thumb} height="100" width="100" />
            </Stack>


            <Stack direction="row" sx={{ flex: '1 0 10%', alignItems: 'center', justifyContent: 'flex-start', ml: 0 }}>
                <Radio
                    sx={{
                        '& .MuiSvgIcon-root': {
                            fontSize: 32,
                            color: actionColor
                        },
                        color: actionColor, fontSize: '18px'
                    }}
                    checked={true} {...label} />
                <Typography color="primary" sx={{fontSize: 20, color: 'text.primary'}}>{data?.approach}</Typography>
            </Stack>

            <Box sx={{ flex: '1 0 15%', ml: 'auto', mr: 'auto' }}>
                <RowText 
                    sx={{
                    borderRadius: 4,
                    backgroundColor: 'grey.300',
                    width: '200px',
                    display: 'block',
                    padding: '5px 10px 5px 10px',
                    ml: 'auto',
                    mr: 'auto'
                }} >
                    {data?.tags}
                </RowText>
            </Box>

            <Box sx={{ flex: '1 0 10%' }}>
                <RowText>{data?.location}</RowText>
            </Box>

            <Box sx={{ flex: '1 0 10%' }}>
                <RowText>${data?.roiValue}</RowText>
            </Box>

            <Box sx={{
                flex: '1 0 10%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center'
            }}>
                <Typography sx={{
                    borderRadius: 1,
                    backgroundColor: 'success.dark',
                    width: '100px',
                    color: 'text.primary',
                    fontWeight: 'bold',
                    display: 'block',
                    padding: '5px 10px 5px 10px',
                    textAlign: 'center',
                    fontSize: 20 
                }} >{data?.enabled ? 'Enabled' : 'Disabled'}</Typography>
            </Box>

            <Box sx={{ flex: '1 0 10%' }}>
                <RowText sx={{ fontSize: 20  }}>{data?.mask ? 'Mask' : 'No Mask'}</RowText>
            </Box>

            <Box sx={{ flex: '1 0 15%' }}>
                <RowText>{data?.enrollmentDate}</RowText>
            </Box>

        </Stack>
    )

}
